import { combineReducers } from 'redux';

import {
  fetchSubsidizedStudentsTypes,
  fetchStudentSubsidyTransactionsTypes,
  addSubsidyCreditsTypes,
  createSubsidyTypes,
  CLEAR_PAYMENT_STATUS,
} from './action_types';

import { makeRequestReducer } from '../../config/client';

const list = makeRequestReducer({
  types: fetchSubsidizedStudentsTypes,
  name: 'subsidizedStudents',
  mutate: (state, res) => ({
    order: res,
  }),
});

const paymentStatus = makeRequestReducer({
  types: addSubsidyCreditsTypes,
  name: 'addSubsidyCredits',
  append: [(state, action) => {
    switch (action.type) {
      case CLEAR_PAYMENT_STATUS:
        return { ...state, data: '' };
      default:
        return state;
    }
  }],
});

const transactions = makeRequestReducer({
  types: fetchStudentSubsidyTransactionsTypes,
  name: 'studentSubsidyTransactions',
  mutate: (state, res) => ({
    list: res,
  }),
});

export default combineReducers({
  list,
  paymentStatus,
  transactions,
});



// WEBPACK FOOTER //
// ./src/modules/subsidy/reducers.js